import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	label: {
		id: 'opsgenie-schedule.components.more-menu.label',
		defaultMessage: 'More',
		description: 'A meatball menu button used to show other actions',
	},
	changeLinkedTeam: {
		id: 'opsgenie-schedule.components.more-menu.change-linked-team',
		defaultMessage: 'Change connected Opsgenie team',
		description:
			'A menu option to allow a user to change the Opsgenie team connected to the Jira project',
	},
	optOutOnCallSchedule: {
		id: 'opsgenie-schedule.components.more-menu.opt-out-on-call-schedule',
		defaultMessage: 'Hide On-call in project',
		description: 'A menu option to allow a user to hide On-call in projects',
	},
});

export default messages;
